"use strict";

var e = require("react"),
    t = require("@patternfly/react-core"),
    n = require("react-router-dom"),
    a = require("date-fns"),
    r = require("react-router-last-location");

function o(a) {
  var r = a.title,
      o = a.to;
  return r && o ? e.createElement(t.NavItem, null, e.createElement(n.NavLink, {
    to: o,
    exact: a.exact,
    activeClassName: "pf-m-current"
  }, r)) : e.createElement(t.NavItemSeparator, {
    "data-testid": "navitem-separator"
  });
}

var i = function i(a) {
  var r = a.title,
      i = a.items,
      u = !!n.useRouteMatch({
    path: a.to
  });
  return e.createElement(t.NavExpandable, {
    title: r,
    isActive: u,
    isExpanded: u
  }, i.map(function (t, n) {
    return e.createElement(o, Object.assign({}, t, {
      key: n
    }));
  }));
},
    u = function u(n) {
  return e.createElement(t.NavGroup, {
    title: n.title
  }, n.items.map(function (t, n) {
    return e.createElement(o, Object.assign({}, t, {
      key: n
    }));
  }));
},
    c = e.createContext({
  setBreadcrumb: function setBreadcrumb() {}
});

function l(e, t) {
  if (null == e) return {};
  var n,
      a,
      r = {},
      o = Object.keys(e);

  for (a = 0; a < o.length; a++) {
    t.indexOf(n = o[a]) >= 0 || (r[n] = e[n]);
  }

  return r;
}

var s = function s() {
  return e.createElement(t.PageSection, {
    "aria-label": "Loading Content Container"
  }, e.createElement(t.EmptyState, {
    variant: t.EmptyStateVariant.full
  }, e.createElement(t.EmptyStateIcon, {
    variant: "container",
    component: t.Spinner
  }), e.createElement(t.Title, {
    size: "lg",
    headingLevel: "h1"
  }, "Loading")));
};

function m(e, t) {
  return void 0 === t && (t = 50), window.setTimeout(function () {
    var t = document.getElementById(e);
    t && t.focus();
  }, t);
}

var p = function p(t) {
  void 0 === t && (t = "main-container");
  var n = r.useLastLocation(),
      a = e.useRef();
  e.useEffect(function () {
    var e,
        r = !0;
    return null !== n && (a.current = n, r = !1, e = m(t, 50)), function () {
      e && r && clearTimeout(e);
    };
  }, [t, n, a]);
};

function v(t) {
  e.useEffect(function () {
    var e = document.title;
    return document.title = t, function () {
      document.title = e;
    };
  }, [t]);
}

var d = function d() {
  return p(), v("Page not found"), e.createElement(t.PageSection, null, e.createElement(t.Alert, {
    variant: "danger",
    title: "404! This view hasn't been created yet."
  }), e.createElement("br", null), e.createElement(n.NavLink, {
    to: "/",
    className: "pf-c-nav__link"
  }, "Take me home"));
};

exports.AppLayout = function (n) {
  var a = n.logo,
      r = n.logoProps,
      l = n.navVariant,
      s = void 0 === l ? "horizontal" : l,
      m = n.navItems,
      p = void 0 === m ? [] : m,
      v = n.navGroupsStyle,
      d = void 0 === v ? "grouped" : v,
      f = n.headerTools,
      E = n.startWithOpenNav,
      g = void 0 === E || E,
      h = n.theme,
      b = void 0 === h ? "dark" : h,
      x = n.mainContainerId,
      y = void 0 === x ? "main-container" : x,
      N = n.children,
      C = e.useState(g),
      S = C[0],
      k = C[1],
      w = e.useState(!0),
      R = w[0],
      L = w[1],
      O = e.useState(!1),
      P = O[0],
      T = O[1],
      D = e.useState(),
      A = D[0],
      I = D[1],
      j = e.useRef(),
      F = e.useCallback(function (e) {
    j.current !== e && (j.current = e, I(j.current));
  }, [I, j]),
      M = e.useCallback(function () {
    T(!P);
  }, [T, P]),
      z = e.useCallback(function () {
    k(!S);
  }, [k, S]);
  e.useEffect(function () {
    k(g);
  }, [g, k]);
  var B = "vertical" === s,
      q = B ? "default" : "horizontal",
      G = e.useMemo(function () {
    return p.length > 0 ? e.createElement(t.Nav, {
      id: "nav-primary-simple",
      theme: b,
      variant: q
    }, e.createElement(t.NavList, {
      id: "nav-list-simple"
    }, p.map(function (t, n) {
      return t && t.hasOwnProperty("items") && B ? e.createElement("expandable" === d ? i : u, Object.assign({}, t, {
        key: n
      })) : e.createElement(o, Object.assign({}, t, {
        key: n
      }));
    }))) : null;
  }, [B, d, p, b, q]),
      V = e.useMemo(function () {
    return e.createElement(t.PageHeader, {
      logo: a,
      logoProps: r,
      headerTools: f,
      showNavToggle: B,
      isNavOpen: B ? S : void 0,
      onNavToggle: R ? M : z,
      topNav: B ? void 0 : G
    });
  }, [a, r, f, B, S, R, M, z, G]),
      H = e.useMemo(function () {
    return "vertical" === s ? e.createElement(t.PageSidebar, {
      nav: G,
      isNavOpen: R ? P : S,
      theme: b,
      "data-testid": "app-sidebar"
    }) : void 0;
  }, [s, G, R, P, S, b]);
  return e.createElement(c.Provider, {
    value: {
      setBreadcrumb: F
    }
  }, e.createElement(t.Page, {
    mainContainerId: y,
    header: V,
    sidebar: H,
    breadcrumb: A,
    onPageResize: function onPageResize(e) {
      L(e.mobileView);
    },
    skipToContent: e.createElement(t.SkipToContent, {
      href: "#primary-app-container"
    }, "Skip to Content")
  }, N));
}, exports.AppLayoutContext = c, exports.AppNavExpandable = i, exports.AppNavGroup = u, exports.AppNavItem = o, exports.FormatDate = function (t) {
  var n = t.date,
      r = t.format,
      o = void 0 === r ? "Pp" : r,
      i = t.options;
  return n = "string" == typeof n ? new Date(n) : n, e.createElement(e.Fragment, null, a.format(n, o, i));
}, exports.FormatDistance = function (t) {
  var n = t.date,
      r = t.base,
      o = void 0 === r ? new Date() : r,
      i = t.options;
  return n = "string" == typeof n ? new Date(n) : n, e.createElement(e.Fragment, null, a.formatDistance(n, o, i));
}, exports.FormatRelative = function (t) {
  var n = t.date,
      r = t.base,
      o = void 0 === r ? new Date() : r,
      i = t.options;
  return n = "string" == typeof n ? new Date(n) : n, e.createElement(e.Fragment, null, a.formatRelative(n, o, i));
}, exports.LazyRoute = function (t) {
  var a = t.getComponent,
      r = l(t, ["getComponent"]),
      o = e.useMemo(function () {
    return e.lazy(a);
  }, [a]);
  return e.createElement(n.Route, Object.assign({}, r), e.createElement(e.Suspense, {
    fallback: e.createElement(s, null)
  }, e.createElement(o, null)));
}, exports.Loading = s, exports.NotFound = d, exports.SwitchWith404 = function (t) {
  var a = t.children,
      r = l(t, ["children"]),
      o = n.useRouteMatch(),
      i = e.useMemo(function () {
    return o && e.createElement(n.Route, {
      path: o.path,
      exact: !0
    });
  }, [o]);
  return e.createElement(n.Switch, Object.assign({}, r), a, i, e.createElement(n.Route, null, e.createElement(d, null)));
}, exports.accessibleRouteChangeHandler = m, exports.useA11yRouteChange = p, exports.useBreadcrumb = function (t) {
  var n = e.useContext(c);
  e.useEffect(function () {
    return n.setBreadcrumb(t), function () {
      n.setBreadcrumb(null);
    };
  }, [n, t]);
}, exports.useDocumentTitle = v;